/**
 * An installer can get the parte at several addresses (e.g. two mailboxes of
 * the same company). They are stored in one field, separated by commas.
 */

const EMAIL = /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+$/;

export interface ParsedEmails {
  /** Valid addresses, lower case, without repeats */
  emails: string[];
  /** Pieces that are not an email address */
  invalid: string[];
}

/** "a@x.com; B@x.com  a@x.com" → emails [a@x.com, b@x.com]. */
export const parseEmails = (text: string): ParsedEmails => {
  const pieces = text
    .split(/[,;\s]+/)
    .map((piece) => piece.trim().toLowerCase())
    .filter(Boolean);
  return {
    emails: [...new Set(pieces.filter((piece) => EMAIL.test(piece)))],
    invalid: pieces.filter((piece) => !EMAIL.test(piece)),
  };
};

/** How the addresses are stored: "a@x.com, b@x.com", or null if none. */
export const formatEmails = (emails: string[]): string | null =>
  emails.length ? emails.join(", ") : null;
